// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"9ab955f0","155":"04ede4f8","425":"5a322060","640":"9dc93cef","960":"8a291b34","968":"7fd385d4"}[chunkId] + ".chunk.js";
};